var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailsvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Mail"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.46267 10.0835C5.73671 10.0835 5.06121 10.2937 4.4902 10.6619L25.6822 29.694C26.8065 30.7031 28.1522 30.7031 29.2788 29.694L50.5094 10.6619C49.9388 10.2937 49.263 10.0835 48.537 10.0835H6.46233H6.46267ZM2.96278 12.677C2.83416 13.0662 2.75 13.4781 2.75 13.9136V42.0029C2.75 44.1248 4.40558 45.8335 6.46269 45.8335H48.5373C50.5939 45.8335 52.25 44.1253 52.25 42.0029V13.9136C52.25 13.4781 52.1658 13.0662 52.0372 12.6765L30.9027 31.6094C28.9324 33.3746 26.0277 33.3778 24.0579 31.6094L2.96205 12.6765L2.96278 12.677Z",
    fill: "#FCAF17"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailsvg);
export default __webpack_public_path__ + "static/media/mailsvg.ae60a0bf94ad4f61ec9b42abdfe3a7ca.svg";
export { ForwardRef as ReactComponent };